import { useMutation } from "@tanstack/react-query";
import { getWeekSpendingTime } from "../../queries/ScheduleHub";

export const useGetHubWeekTime = () => {
  const { data, isPending, isError, mutate } = useMutation({
    mutationKey: ['getHubWeekTime'],
    mutationFn: (idCronograma: string) => getWeekSpendingTime(idCronograma),
    retry: false,
  });

  return { mutate, isPending, isError, data };
};